
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import HomeContent from "@/components/home/HomeContent.vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import store from "@/store";
import LearnMore from "@/components/common/LearnMore.vue";

export default Vue.extend({
  name: "Home",
  components: {
    HeroBanner,
    HomeContent,
    LearnMore,
  },
  mixins: [UIFeatureMixin],
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "HME_SHRRD,HME_FXRT,HME_ALLOPT,HME_MAIN,OLD_65,WHL_CHR,MONEY,LAPTOP,HME_TRANS,HME_FOOTER,HME_HERO_C,HME_SEC1,FMR_APPLY,FLT_CNTIES,OVERVIEW,HME_LEARN"
    );
  },
  computed: {
    isDataLoading: {
      get(): boolean {
        return store.getters.uiFeatureModule.getLoadingStatus;
      },
    },
  },
});
